import React, { useEffect, useState } from 'react';

const style = `
 .timer {
    width: 10rem;
    height: 2rem;
    display: flex;
    
  }
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 2rem;                
  }
  .en {
    display: flex;
    align-items: center;
    margin-left: 0.3rem;        
    height: 2rem;        
  
  }
  .finish_ment {        
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    white-space: pre-line;
    font-size: 1rem;
  }
`;

const CountDown = ({ time }) => {
  const [finish, setFinish] = useState(false);
  const [hours, setHours] = useState(null);
  const [minutes, setMinutes] = useState(null);
  const [seconds, setSeconds] = useState(null);

  useEffect(() => {
    setFinish(false);
    const future = Date.parse(
      `${time?.year}/${time?.month}/${time?.date} ${time?.hour}:${time?.min}:${time?.sec}`
    );

    const interval = setInterval(() => {
      const now: any = new Date();
      const diff = future - now;
      if (diff <= 0 || isNaN(diff)) {
        setFinish(true);
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const mins = Math.floor(diff / (1000 * 60));
      const secs = Math.floor(diff / 1000);

      const d = days;
      const h = hours - days * 24;
      const m = mins - hours * 60;
      const s = secs - mins * 60;

      const date = h + d * 24;
      setHours(date);
      setMinutes(m);
      setSeconds(s);
    }, 1000);

    return () => clearInterval(interval);
  }, [time]);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />

      {finish ? (
        <span className="finish_ment">종료되었습니다.</span>
      ) : (
        <span className="timer" id="timer">
          <li>
            <span>{hours}</span>
            <span className="en">:</span>
          </li>
          <li>
            <span>{minutes}</span>
            <span className="en">:</span>
          </li>
          <li>
            <span>{seconds}</span>
          </li>
        </span>
      )}
    </>
  );
};

export default CountDown;
